// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Jdmo","right":"styles_right__1FWI7"};